
import bitkubConfig from "./config/bitkubConfig";

export default {
    config: function (mainApp) {
        var config = null;
        switch (mainApp) {
            case 'bitkub':
                config = bitkubConfig.config();
                break;
        }
        return config;
    },
}
